import { parseAmountToCents } from "@/shared/lib";

export interface ServiceFormShape {
  serviceId: string | null
  duration: string
  price: string
  buffer: string
}

export type ServiceFormErrors = Partial<Record<"service" | "duration" | "price" | "buffer", string>>

/**
 * Синхронна клієнтська валідація форми послуги майстра.
 * Повертає об'єкт i18n-ключів помилок; порожній об'єкт = форма коректна.
 *
 * add — перевіряє serviceId; edit — ні (serviceId вже зафіксований).
 */
export function validateServiceForm(
  form: ServiceFormShape,
  mode: "add" | "edit",
): ServiceFormErrors {
  const errors: ServiceFormErrors = {};

  if (mode === "add" && !form.serviceId) {
    errors.service = "masters.services.errors.serviceRequired";
  }

  // duration: цілий > 0; порожній рядок, 0, від'ємний, дробовий — помилка.
  if (!form.duration || !/^\d+$/.test(form.duration) || parseInt(form.duration, 10) <= 0) {
    errors.duration = "masters.services.errors.invalidDuration";
  }

  // price: порожній → 0 (ок); непорожній — парситься parseAmountToCents; NaN → помилка.
  if (form.price !== "" && isNaN(parseAmountToCents(form.price))) {
    errors.price = "masters.services.errors.invalidPrice";
  }

  // buffer: порожній → 0 (ок); непорожній — цілий >= 0 без дробової частини.
  if (form.buffer !== "" && !/^\d+$/.test(form.buffer)) {
    errors.buffer = "masters.services.errors.invalidBuffer";
  }

  return errors;
}
